package navigation.home.contact

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.contact.domain.repository.ContactRepository
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.contact.ui.ContactValidation
import com.essntl.features.contact.ui.ContactViewModel

class ContactScreenModel(
    contactRepository: ContactRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<ContactState>(ContactState()) {
    val validation = ContactValidation()

    val vm =
        ContactViewModel(
            contactRepository = contactRepository,
            loadingManager = loadingManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: ContactEvent) = vm.onEvent(event)
}